import { render, staticRenderFns } from "./ViewSuspensions.vue?vue&type=template&id=d93d0278&"
import script from "./ViewSuspensions.vue?vue&type=script&lang=js&"
export * from "./ViewSuspensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports